import { BalButton } from "@baloise/ds-react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

import { StepperNavigationProps } from "./stepperNavigation.types";
import * as style from "./steppernavigation.module.scss";

/**
 * StepperNavigation
 */
const StepperNavigation: React.FC<StepperNavigationProps> = ({
    isNextButtonDisabled,
    validate,
    hasSmallContainer,
    currentPage,
    next,
    prev,
    interruptNavigation = () => false,
}) => {
    const { t } = useTranslation();

    const nextAction = async () => {
        const valid = validate ? await validate() : true;
        if (valid && !interruptNavigation()) {
            next();
        }
    };

    return (
        <div
            className={`container mt-large ${
                hasSmallContainer ? "overwritecontainer" : ""
            }`}
        >
            <div className={`flex ${style.steppernavigation}`}>
                {currentPage?.prevPage && (
                    <BalButton
                        data-cy="previous-button"
                        className="mr-normal lg-previous"
                        color={currentPage.buttons.prev.type}
                        href={
                            currentPage.isPrevPageExternal
                                ? currentPage.prevPage
                                : undefined
                        }
                        onClick={() => {
                            prev();
                        }}
                        icon={currentPage.buttons.prev.icon}
                        iconRight={currentPage.buttons.prev.iconRight}
                    >
                        <>{t(currentPage?.buttons.prev.text)}</>
                    </BalButton>
                )}

                {currentPage?.nextPage && (
                    <BalButton
                        data-cy="next-button"
                        className="lg-next"
                        color={currentPage.buttons.next.type}
                        disabled={isNextButtonDisabled}
                        href={
                            currentPage.isNextPageExternal
                                ? currentPage.nextPage
                                : undefined
                        }
                        onClick={() => {
                            nextAction();
                        }}
                        icon={currentPage.buttons.next.icon}
                        iconRight={currentPage.buttons.next.iconRight}
                    >
                        <>{t(currentPage?.buttons.next.text)}</>
                    </BalButton>
                )}
            </div>
        </div>
    );
};

export default StepperNavigation;
